import { memo, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, type SelectProps } from '@mui/material';
import { Select } from 'components/mui/common/Select';
import type { RadioButtonFormItem } from '../../../../../types';
import type { FormItemUiDefinition } from 'types/formItem';
import { toRadioButtonOptions } from 'utils/formItem/radioButtonChoice';

type Props = SelectProps & {
  value: string;
  items?: RadioButtonFormItem['items'];
  disabled?: boolean;
  isClickable?: boolean;
  helperText?: string;
  background?: 'white' | 'transparent';
  formItemUiDefinition?: FormItemUiDefinition;
};

const SelectEditableBase = forwardRef<HTMLSelectElement, Props>(
  ({ value, disabled, items, error, helperText, formItemUiDefinition, ...field }, ref) => {
    const { i18n } = useTranslation();
    const options = toRadioButtonOptions(items, i18n.language);

    return (
      <Select
        {...field}
        ref={ref}
        value={value}
        disabled={disabled}
        error={Boolean(error)}
        helperText={helperText}
        formItemUiDefinition={formItemUiDefinition}
        displayEmpty>
        {options.map(({ label, value: optionValue, id }, index) => (
          <MenuItem key={`${id}-${index}`} value={optionValue}>
            {label}
          </MenuItem>
        ))}
      </Select>
    );
  }
);

export const SelectEditable = memo(SelectEditableBase) as typeof SelectEditableBase;
